module.exports = __webpack_public_path__ + "img/BVillager64_ua.e7233149.webp";